export default "__VITE_ASSET__BEbyBA4A__"